export const getChannelFromUrl = (
    defaultChannel: string | null = 'seo_top'
): string | null => {
    // NOTE: API.ENDPOINTS.SIGNUP がモジュール読み込み時にこれを呼ぶため、DOMの無い環境で
    // このモジュールをimportしただけで落ちないようにする
    // （tests/.../pulldown/searchResultsClickLabel.test.tsx が @jest-environment node）
    if (typeof window === 'undefined') return defaultChannel

    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('channel') || defaultChannel
}

export const getFbclid = (): string => {
    const urlParams = new URLSearchParams(window.location.search)
    const fbclidFromUrl = urlParams.get('fbclid')
    const fbclid = fbclidFromUrl || window.localStorage.getItem('fbclid') || ''

    if (fbclidFromUrl && typeof window !== 'undefined') {
        window.localStorage?.setItem('fbclid', fbclidFromUrl)
    }

    return fbclid
}

export const API = {
    ENDPOINTS: {
        CITIES: '/api/v1/cities/search.json',
        SIGNUP: `/signup?channel=${getChannelFromUrl()}`,
        AG_PREFILL: '/api/v1/users/ag_prefill',
        FAVORITE_OFFER: (offerId: string): string =>
            `/api/v1/favorite_offers/${offerId}/favorite`,
        UNFAVORITE_OFFER: (offerId: string): string =>
            `/api/v1/favorite_offers/${offerId}/unfavorite`,
        FAVORITE_OFFERS: (offerIds: string[]): string =>
            `/api/v1/favorite_offers?${offerIds
                .map(id => `offer_ids[]=${encodeURIComponent(id)}`)
                .join('&')}`,
    },
    HEADERS: {
        CONTENT_TYPE: 'application/json',
    },
} as const

/** <meta name="csrf-token"> から Rails の CSRF トークンを取得する(無ければ空文字) */
export const getCsrfToken = (): string =>
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
        ?.content ?? ''

/**
 * 共通の fetch ラッパー。
 * JSON 用の共通ヘッダー(Content-Type / Accept / X-CSRF-Token)を付与し、
 * レスポンスを JSON としてパースして返す simple な wrapper。
 * 追加・上書きしたいヘッダーは options.headers で渡す。
 */
export const apiFetch = async <T>(
    url: string,
    options: {
        method?: string
        body?: string
        headers?: Record<string, string>
        signal?: AbortSignal
    } = {}
): Promise<T> => {
    const response = await fetch(url, {
        ...options,
        headers: {
            'Content-Type': API.HEADERS.CONTENT_TYPE,
            Accept: API.HEADERS.CONTENT_TYPE,
            'X-CSRF-Token': getCsrfToken(),
            ...options.headers,
        },
    })

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json() as Promise<T>
}
